module.exports = __webpack_public_path__ + "img/44.47448985.jpg";